(function () {
  const STORAGE_KEY = 'template-session-rules';

  /** @param {string} pathname */
  function normalizePath(pathname) {
    if (!pathname) return '/';

    const normalized = pathname.replace(/\/+$/, '');
    return normalized || '/';
  }

  /**
   * @typedef {object} TemplateSessionRule
   * @property {string} id
   * @property {string[]} productPaths
   * @property {string} queryParamName
   * @property {string} queryParamValue
   * @property {boolean} [overrideExistingParam]
   */

  /** @returns {TemplateSessionRule[]} */
  function readRules() {
    try {
      const rawValue = window.localStorage.getItem(STORAGE_KEY);
      const parsedValue = rawValue ? JSON.parse(rawValue) : [];
      return Array.isArray(parsedValue) ? parsedValue : [];
    } catch (error) {
      return [];
    }
  }

  /** @param {string} pathname */
  function getMatchingRule(pathname) {
    const normalizedPath = normalizePath(pathname);
    const rules = readRules();

    for (let index = rules.length - 1; index >= 0; index -= 1) {
      const rule = rules[index];

      if (!rule || !Array.isArray(rule.productPaths)) continue;
      if (rule.productPaths.includes(normalizedPath)) return rule;
    }

    return null;
  }

  /**
   * @param {URL} url
   * @param {TemplateSessionRule | null} rule
   */
  function buildRuleUrl(url, rule) {
    if (!rule || !rule.queryParamName || !rule.queryParamValue) return url;

    const nextUrl = new URL(url.toString());
    const currentValue = nextUrl.searchParams.get(rule.queryParamName);

    if (currentValue === rule.queryParamValue) return nextUrl;
    if (currentValue && !rule.overrideExistingParam) return nextUrl;

    nextUrl.searchParams.set(rule.queryParamName, rule.queryParamValue);
    return nextUrl;
  }

  /** @param {HTMLAnchorElement} anchor */
  function decorateAnchor(anchor) {
    if (!(anchor instanceof HTMLAnchorElement) || !anchor.href) return;

    let anchorUrl;

    try {
      anchorUrl = new URL(anchor.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (anchorUrl.origin !== window.location.origin) return;

    const rule = getMatchingRule(anchorUrl.pathname);
    if (!rule) return;

    const nextUrl = buildRuleUrl(anchorUrl, rule);
    if (nextUrl.toString() !== anchorUrl.toString()) {
      anchor.href = nextUrl.toString();
    }
  }

  /** @param {Element | Document} root */
  function decorateAnchors(root) {
    if (!(root instanceof Element) && !(root instanceof Document)) return;

    root.querySelectorAll('a[href]').forEach((anchor) => {
      if (anchor instanceof HTMLAnchorElement) {
        decorateAnchor(anchor);
      }
    });
  }

  function maybeRedirectCurrentPage() {
    const rule = getMatchingRule(window.location.pathname);
    if (!rule) return;

    const currentUrl = new URL(window.location.href);
    const nextUrl = buildRuleUrl(currentUrl, rule);

    if (nextUrl.toString() !== currentUrl.toString()) {
      window.location.replace(nextUrl.toString());
    }
  }

  maybeRedirectCurrentPage();

  document.addEventListener('DOMContentLoaded', function () {
    decorateAnchors(document);
  });

  document.addEventListener(
    'pointerdown',
    function (event) {
      const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (anchor instanceof HTMLAnchorElement) decorateAnchor(anchor);
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (event) {
      const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (anchor instanceof HTMLAnchorElement) decorateAnchor(anchor);
    },
    true
  );
})();